exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attachable-show-component[data-v-6e7db4c2] {\n  padding: 15px 10px;\n  border: solid 1px #ccc;\n  border-radius: 4px;\n}\n\n", ""]);

// exports
